module.exports = __webpack_public_path__ + "static/img/004.1b5a915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/004.png
// module id = TzqA
// module chunks = 1